import produce from "immer";
import img from "./../../../assets/logo.png"
import types from "./types";

const INITIAL_STATE = {
  behavior: "create",
  tipoReserva:"reservar",
  components: {
    drawer: false,
    confirmDelete: false,
    view:"week"
  },
  form: {
    filtering: false,
    disabled: true,
    saving: false,
  },
  carrosDisponivel:[],
  reservaCarrosCliente:[ 
  ],
  carros:[],
  carros_liverados:[],
  carros_Alugados:[],
  reservations: {
    id: null,
    status: "",
    destiny: "",
    users_id: null,
    cost_centers_id: null,
    start_date: "2022-08-15T13:22:18",
    end_date: "2022-08-16T13:22:18",
    withdrawn_date: "",
    back_date: "",
    created_at: "",
    updated_at: "",
    vehicles_id: null,
    withdrawn_users_id: null,
    back_users_id: null,
    user_observations: "",
    company_observations: "",
  },
  reservations_details: {
    id: null,
    start_odometer: "",
    end_odometer: "",
    extinguisher: "",
    car_jack: "",
    triangle: "",
    tire_iron: "",
    structure: "",
    painting: "",
    steppe: "",
    document: "",
    reservations_detailscol: "",
    reservations_id: "",
  },
  reservations_expenses: {
    id: "",
    fuel: "",
    toll: "",
    parking: "",
    meals: "",
    reservations_id: "",
  },
  extra_time_users: {
    extra_time_id: null,
    users_id: null,
  },
  extra_time: {
    id: null,
    name: "",
    datetime: "",
    type: "",
    minutes_to: null,
    active: false,
  },
  users: {
    id: null,
    name: "",
    email: "",
    cpf: "",
    phone_number: "",
    address: "",
    address_number: "",
    address_complement: "",
    address_district: "",
    address_city: "",
    address_state: "",
    address_zipcode: "",
    password: "",
    created_at: "",
    updated_at: "",
    active: false,
  },
  users_licenses: {
    id: "",
    photo: "",
    number: "",
    valid_to: "",
    category: "",
    users_id: "",
    active: "",
  },
  users_cost_centers: {
    users_id: null,
    cost_centers_id: null,
  },
  cost_centers: {
    id: null,
    name: "",
    active: false,
    areas_id: null,
  },
  areas: {
    id: null,
    name: "",
    active: false,
  },
  vehicles: {
    id: null,
    license: "",
    model: "",
    odometer: null,
    consumption: null,
    photo: "",
    active: false,
    brands_id: null,
    status: "",
  },
  brands: {
    id: null,
    name: "",
    active: false,
  },
};

function reserva(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.UPDATE_HORARIO_RESERVA: {
      return produce(state, (draft) => {
        draft = { ...draft, ...action.payload };
        return draft;
      });
    }
    case types.RESET_HORARIO_RESERVA: {
      return produce(state, (draft) => {
        draft.reservations = INITIAL_STATE.reservations;
        return draft;
      });
    }
    default:
      return state;
  }
}

export default reserva;
